import React, { useState, createContext, useEffect } from 'react'
import { trackModalClosed, trackModalViewed } from '../events'

interface ContextProviderProps {
  mobileImage: string | null | undefined
  desktopImage: string | null | undefined
  slug: string | null | undefined
  episodeSlug: string | null | undefined
  children: React.ReactNode
}

export interface GetNotifiedModalContextValue {
  mobileImage: string | null | undefined
  desktopImage: string | null | undefined
  slug: string | null | undefined
  episodeSlug: string | null | undefined
  showModal: boolean
  closeModal: () => void
  openModal: () => void
  showToast: boolean
  onEmailCaptured: () => void
}

const GetNotifiedModalContext =
  createContext<GetNotifiedModalContextValue | null>(null)

export const GetNotifiedModalContextProvider = ({
  mobileImage,
  desktopImage,
  slug,
  episodeSlug,
  children,
}: ContextProviderProps) => {
  const [showModal, setShowModal] = useState(false)
  const [showToast, setShowToast] = useState(false)

  useEffect(() => {
    if (showModal) {
      trackModalViewed({ episodeSlug, slug })
    }
  }, [showModal, episodeSlug, slug])

  const closeModal = () => {
    setShowModal(false)
    trackModalClosed({ episodeSlug, slug })
  }

  const openModal = () => {
    setShowToast(false)
    setShowModal(true)
  }

  const onEmailCaptured = () => {
    setShowModal(false)
    setShowToast(true)
  }

  return (
    <GetNotifiedModalContext.Provider
      value={{
        mobileImage,
        desktopImage,
        slug,
        episodeSlug,
        showModal,
        closeModal,
        openModal,
        showToast,
        onEmailCaptured,
      }}
    >
      {children}
    </GetNotifiedModalContext.Provider>
  )
}

export const useGetNotifiedModal = () => {
  const ctx = React.useContext(GetNotifiedModalContext)
  if (!ctx) {
    throw new Error(
      'GetNotifiedModalContext cannot be used outside of GetNotifiedModalContextProvider',
    )
  }
  return ctx
}
